import { render, staticRenderFns } from "./payment-case.vue?vue&type=template&id=22f83ed0"
import script from "./payment-case.vue?vue&type=script&lang=ts"
export * from "./payment-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports